const pms_loan_terms = [
  /*  { value: "40_6_months", name: "40/6 Months" },
  { value: "40_9_months", name: "40/9 Months" },
  { value: "40_1_year", name: "40/1 Year" },
  { value: "40_2_years", name: "40/2 Years" },
  { value: "40_3_years", name: "40/3 Years" },
  { value: "40_5_years", name: "40/5 Years" },
  { value: "30_3_years", name: "30/3 Years" },
  { value: "30_5_years", name: "30/5 Years" }, */
  { value: "i_o_due_in_6_months", name: "I/O due in 6 months" },
  { value: "i_o_due_in_1_year", name: "I/O due in 1 year" },
  { value: "i_o_due_in_2_years", name: "I/O due in 2 years" },
  { value: "i_o_due_in_3_years", name: "I/O due in 3 years" },
  { value: "i_o_due_in_5_years", name: "I/O due in 5 years" },
  /* { value: "i_o_due_in_7_years", name: "I/O due in 7 years" }, */
  /* { value: "i_o_due_in_9_months", name: "I/O due in 9 months" }, */
];

export default pms_loan_terms;



// WEBPACK FOOTER //
// ./src/constants/pms_loan_terms.js